import { useAuth0 } from "@auth0/auth0-react";
import { MenuItem } from "@mui/material";
import React from "react";
import { tokens } from "../theme";

export default function UserInfo() {

    const {isAuthenticated, user} = useAuth0();

    return (
        <>
            {(isAuthenticated) ?
                (
                    <>
                        <MenuItem
                            disabled={true}
                            sx={{"&.Mui-disabled": {
                                    color: tokens.text,
                                    opacity: 0.7,
                                }}}
                        >{user.name} ({user.email})</MenuItem>
                    </>
                )
                :
                (<></>)
            }
        </>
    )
}